<script>
import CookieSettingsButton from '../../../../main/vue/cookies/components/CookieSettingsButton.vue'

export default {
  name: 'CookieSettingsButton',
  extends: CookieSettingsButton
}
</script>
